module.exports = __webpack_public_path__ + "static/media/bus-travellers.93038e38.png";